module.exports = __webpack_public_path__ + "static/media/price-tag.eaf6087e.svg";